import React from "react";
import sampleData from "../../../../utility/sampleData";
import Alert from "../../../../common/components/Alert/Alert";
import Button, { ButtonSizes } from "../../../../common/components/Forms/Button/Button";
import Checkbox from "../../../../common/components/Forms/Checkbox/Checkbox";
import Dropdown from "../../../../common/components/Forms/Dropdown/Dropdown";
import Input from "../../../../common/components/Forms/Input/Input";
import Occupation from "../../../../common/components/Forms/Occupation/Occupation";
import Toggle from "../../../../common/components/Forms/Toggle/Toggle";
import Icon from "../../../../common/components/Icon/Icon";
import QuoteBreakdownSummary from "../../../../common/components/QuoteBreakdown/QuoteBreakdownSummary/QuoteBreakdownSummary";
import { Severity } from "../../../../common/interfaces/enums/Severity";

const ButtonSizeList: ButtonSizes[] = ["xl", "l", "m", "s", "xs"];

const AlertTypeList: Severity[] = [Severity.Error, Severity.Success, Severity.Info];

const StyleGuideComponents: React.FC = () => {
    return (
        <article className="layout-content-container">
            <h2>Buttons</h2>
            {ButtonSizeList.map((size) => {
                return (
                    <div key={size} className="layout-flex-column gap-ml">
                        <h3>Size - {size}</h3>
                        <Button
                            component="button"
                            variant="default"
                            size={size}
                            className="gap-s">
                            Style - Default
                        </Button>
                        <Button
                            component="button"
                            variant="calltoaction"
                            size={size}
                            className="gap-s">
                            Style - CallToAction
                        </Button>
                        <Button
                            component="button"
                            variant="select"
                            size={size}
                            className="gap-s">
                            Style - Select
                        </Button>
                        <Button
                            component="button"
                            variant="box"
                            size={size}
                            className="gap-s">
                            <Icon id="TrashCan" />
                        </Button>
                    </div>
                );
            })}
            <h2>Checkbox</h2>
            <div className="layout-flex-row">
                <div className="layout-flex-column space-4xl">
                    <h3>Size Medium</h3>
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="m"
                        label="Checked"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked={false}
                        className="gap-m"
                        name="checkbox"
                        size="m"
                        label="Unchecked"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="m"
                        label="Disabled"
                        isDisabled
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="m"
                        label="Error"
                        hasError="Error Message"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="m"
                        label="With Tooltip"
                        tooltipContent="Tool tips are useful :)"
                        onChange={() => alert("Clicked")}
                    />
                </div>
                <div>
                    <h3>Size Large</h3>
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="l"
                        label="Checked"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked={false}
                        className="gap-m"
                        name="checkbox"
                        size="l"
                        label="Unchecked"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="l"
                        label="Disabled"
                        isDisabled
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="l"
                        label="Error"
                        hasError="Error Message"
                        onChange={() => alert("Clicked")}
                    />
                    <Checkbox
                        checked
                        className="gap-m"
                        name="checkbox"
                        size="l"
                        label="With Tooltip"
                        tooltipContent="Tool tips are useful :)"
                        onChange={() => alert("Clicked")}
                    />
                </div>
            </div>
            <h2>Toggle</h2>
            <Toggle
                label="Label"
                className="gap-m"
                options={[
                    { id: "1", label: "Option 1", selected: true },
                    { id: "2", label: "Option 2" }
                ]}
                name="toggle"
                onChange={() => alert("Clicked")}
            />
            <Toggle
                label="With Error"
                className="gap-m"
                hasError="Error Message"
                options={[
                    { id: "1", label: "Option 1", selected: true },
                    { id: "2", label: "Option 2" }
                ]}
                name="toggle"
                onChange={() => alert("Clicked")}
            />
            <Toggle
                label="Disabled"
                className="gap-m"
                isDisabled
                options={[
                    { id: "1", label: "Option 1", selected: true },
                    { id: "2", label: "Option 2" }
                ]}
                name="toggle"
                onChange={() => alert("Clicked")}
            />
            <h2>Occupation</h2>
            Note: This depends on API calls to work
            <Occupation
                initialValue={{ label: "Initial Value", value: "initial" }}></Occupation>
            <h2>Dropdown</h2>
            <div className="layout-flex-row">
                {([
                    "default",
                    "paymentfreq-full",
                    "paymentfreq-short",
                    "product-sort"
                ] as React.ComponentProps<typeof Dropdown>["variant"][]).map(
                    (variant) => (
                        <div className="space-2xl" key={variant}>
                            <h3>Variant: {variant}</h3>
                            <Dropdown
                                name="dropdown"
                                title="Base"
                                variant={variant}
                                onChange={() => alert("Value selected")}
                                options={[
                                    { value: "1", label: "Option 1" },
                                    { value: "2", label: "Option 2" }
                                ]}
                            />
                            <Dropdown
                                name="dropdown"
                                title="Has Error"
                                hasError="Error Message"
                                variant={variant}
                                onChange={() => alert("Value selected")}
                                options={[
                                    { value: "1", label: "Option 1" },
                                    { value: "2", label: "Option 2" }
                                ]}
                            />
                            <Dropdown
                                name="dropdown"
                                title="Disabled"
                                isDisabled
                                variant={variant}
                                onChange={() => alert("Value selected")}
                                options={[
                                    { value: "1", label: "Option 1" },
                                    { value: "2", label: "Option 2" }
                                ]}
                            />
                        </div>
                    )
                )}
            </div>
            <h2>Inputs</h2>
            <Input
                name="input"
                type="text"
                value="Sample Text Input"
                onChange={() => alert("Change")}
            />
            <h3>Text Area</h3>
            <Input
                name="input"
                type="textarea"
                value="Sample Text Area Input"
                onChange={() => alert("Change")}
            />
            <h3>Number Input</h3>
            <Input
                name="input"
                type="number"
                value={10000}
                onChange={() => alert("Change")}
            />
            <h2>Alerts</h2>
            <div>
                <h3>Standard</h3>
                {AlertTypeList.map((type) => (
                    <Alert key={type} severity={type} className="gap-pre-2xl gap-m">
                        {Severity[type]}
                    </Alert>
                ))}
                <h3>Dismissible</h3>
                {AlertTypeList.map((type) => (
                    <Alert
                        key={type}
                        isDismissible
                        severity={type}
                        className="gap-pre-2xl gap-m">
                        {Severity[type]}
                    </Alert>
                ))}
            </div>
            <h2>Breakdown Card - QuoteBreakdownSummary</h2>
            <div>
                <QuoteBreakdownSummary
                    benefits={sampleData.sampleResultData[0].result.benefits}
                    clients={sampleData.sampleResultData[0].result.clients}
                    isCard
                    providerId={sampleData.sampleResultData[0].result.providerId}
                    settings={sampleData.sampleResultData[0].result.settings}
                    totalCashback={sampleData.sampleResultData[0].totalCashback}
                    totalDiscount={20}
                    size="large"
                    totalPremium={
                        sampleData.sampleResultData[0].result.totalPremium
                    }></QuoteBreakdownSummary>
            </div>
        </article>
    );
};

export default StyleGuideComponents;
